(function(){
  function initSlick($root){
    var $main   = $root.find('.js-product-main');
    var $thumbs = $root.find('.js-product-thumbs');

    if(!$main.length || $main.hasClass('slick-initialized')) return;

    // メイン slick
    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      infinite: false
    });

    // サムネクリックでメインを切替
    if($thumbs.length){
      $thumbs.on('click', '.product-thumbs__slide', function(){
        var mediaId = $(this).data('media-id');
        var index   = $main.find('[data-media-id="'+mediaId+'"]').closest('.slick-slide').data('slick-index');
        if(index != null) $main.slick('slickGoTo', index, true);
      });
    }

    // メインが切り替わったらサムネに active クラス
    $main.on('afterChange', function(e, slick, current){
      var $slides = $thumbs.find('.product-thumbs__slide');
      $slides.removeClass('is-active')
             .eq(current).addClass('is-active');
    });

    // 初期アクティブ
    $thumbs.find('.product-thumbs__slide').eq(0).addClass('is-active');

    // バリアント変更時に該当画像へジャンプ
    document.addEventListener('variant:change', function(ev){
      var variant = ev.detail && ev.detail.variant;
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if(!mediaId) return;
      var index = $main.find('[data-media-id="'+mediaId+'"]').closest('.slick-slide').data('slick-index');
      if(index != null) $main.slick('slickGoTo', index, true);
    });
  }

  $(function(){
    $('[id^="slick-gallery-"]').each(function(){ initSlick($(this)); });
  });
})();
